import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules, NoPreloading } from '@angular/router';
import { PageNotFoundComponent } from './page-not-found.component';
import { AuthGuardService } from './modules/shared/services/auth-guard.service';
import { environment } from 'environments/environment';
import { LoanDetailsModalComponent } from './modules/shared/loan-details-modal/loan-details-modal.component';

const routes: Routes = [
    { path: '', redirectTo: 'login', pathMatch: 'full' },
    {
        path: 'historical-trends',
        loadChildren: () =>
            import('./modules/historical-trends/historical-trends.module').then(
                (m) => m.HistoricalTrendsModule
            ),
        canActivate: [AuthGuardService],
    },
    {
        path: 'home',
        loadChildren: () => import('./modules/home/home.module').then((m) => m.HomeModule),
        canActivate: [AuthGuardService],
    },
    {
        path: 'financials',
        loadChildren: () =>
            import('./modules/incentives/incentives.module').then((m) => m.IncentivesModule),
        canActivate: [AuthGuardService],
    },
    {
        path: 'leads-partners',
        loadChildren: () =>
            import('./modules/leads-partners/leads-partners.module').then(
                (m) => m.LeadsPartnersModule
            ),
        canActivate: [AuthGuardService],
    },
    {
        path: 'login',
        loadChildren: () => import('./modules/login/login.module').then((m) => m.LoginModule),
    },
    {
        path: 'login/:message',
        loadChildren: () => import('./modules/login/login.module').then((m) => m.LoginModule),
    },
    {
        path: 'password-reset',
        loadChildren: () =>
            import('./modules/password-reset/password-reset.module').then(
                (m) => m.PasswordResetModule
            ),
    },
    {
        path: 'performance',
        loadChildren: () =>
            import('./modules/performance/performance.module').then((m) => m.PerformanceModule),
        canActivate: [AuthGuardService],
    },
    {
        path: 'pipeline',
        loadChildren: () =>
            import('./modules/pipeline/pipeline.module').then((m) => m.PipelineModule),
        canActivate: [AuthGuardService],
    },
    {
        path: 'production',
        loadChildren: () =>
            import('./modules/production/production.module').then((m) => m.ProductionModule),
        canActivate: [AuthGuardService],
    },
    {
        path: 'settings',
        loadChildren: () =>
            import('./modules/settings/settings.module').then((m) => m.SettingsModule),
        canActivate: [AuthGuardService],
    },
    {
        path: 'report-menu',
        loadChildren: () => import('./modules/reports/reports.module').then((m) => m.ReportModule),
        canActivate: [AuthGuardService],
    },
    {
        path: 'reporting',
        loadChildren: () => import('./modules/reports/reports.module').then((m) => m.ReportModule),
        canActivate: [AuthGuardService],
    },
    {
        path: 'directory',
        loadChildren: () =>
            import('./modules/directory/directory.module').then((m) => m.DirectoryModule),
        canActivate: [AuthGuardService],
    },
    {
        path: 'my-vision',
        loadChildren: () =>
            import('./modules/my-limegear/my-limegear.module').then(
                (m) => m.CustomDashboardsModule
            ),
        canActivate: [AuthGuardService],
    },
    {
        path: 'loanDetails/:loanNumber',
        component: LoanDetailsModalComponent,
        outlet: 'modal',
        canActivate: [AuthGuardService],
    },
    { path: '**', component: PageNotFoundComponent },
];

@NgModule({
    imports: environment.production
        ? [
              RouterModule.forRoot(routes, {
                  preloadingStrategy: PreloadAllModules,
              }),
          ]
        : [RouterModule.forRoot(routes, {})],
    exports: [RouterModule],
})
export class AppRoutingModule {}
